/**
 * tutorEngagementAdapter — le score d'engagement d'un élève (`statistics.scores` d'un rapport de
 * live) → la forme du masteur (`UITutorEngagement`, celle de `<TutorEngagementBar>`).
 *
 * Les trois axes se lisent comme ceux du rapport du parent (`mapAxis`, `liveReportDetailsAdapter` :
 * libellé, maximum, couleur, détail critère par critère) ; ce fichier n'y ajoute que la clé de l'axe
 * et l'état de la productivité. Jamais importé par le DS.
 */
import { type ApiAxisScore, mapAxis } from "../../parent/LiveReports/liveReportDetailsAdapter"
import {
    type UITutorEngagement,
    type UITutorEngagementAxisKey,
    type UITutorProductivityState,
} from "../../../ui/types/tutorCloseOut"

/** `statistics.scores` tel que le serveur le sert. */
export type ApiEngagementScores = {
    total_score?: number | null
    assiduity?: ApiAxisScore
    interaction?: ApiAxisScore
    productivity?: ApiAxisScore
}

const AXES: UITutorEngagementAxisKey[] = ["assiduity", "interaction", "productivity"]

/** `null` : pas de score (l'ancienne ligne ne montrait rien quand `total_score` manquait). */
export function toUITutorEngagement(
    scores: ApiEngagementScores | null | undefined,
    productivity: UITutorProductivityState = "ready"
): UITutorEngagement | null {
    if (scores == null || scores.total_score == null) return null
    return {
        total: scores.total_score,
        productivity,
        axes: AXES.map((key) => ({ key, ...mapAxis(key, scores[key]) })),
    }
}
